"use strict"

import moment from "moment"

export class SubscriptionPlans {
  static get AntaresAnnualV1() {
    return "antares-annual-v1"
  }

  static get AntaresAnnualV2() {
    return "antares-annual-v2"
  }

  static get NiagaraAnnualV1() {
    return "niagara-annual-v1"
  }

  static get NiagaraMonthlyV1() {
    return "niagara-monthly-v1"
  }

  static get NiagaraAnnualV2() {
    return "niagara-annual-v2"
  }

  static get NiagaraMonthlyV2() {
    return "niagara-monthly-v2"
  }

  static get NiagaraAnnualV3() {
    return "niagara-annual-v3"
  }

  static get NiagaraMonthlyV3() {
    return "niagara-monthly-v3"
  }

  static get NiagaraAnnualV4() {
    return "niagara-annual-v4"
  }

  static get NiagaraMonthlyV4() {
    return "niagara-monthly-v4"
  }

  static get NiagaraAnnualV6() {
    return "niagara-annual-v6"
  }

  static get NiagaraMonthlyV6() {
    return "niagara-monthly-v6"
  }

  static get NiagaraAnnualV7() {
    return "niagara-annual-v7"
  }

  static get NiagaraMonthlyV7() {
    return "niagara-monthly-v7"
  }

  static get NiagaraMonthlyV8() {
    return "niagara-monthly-v8"
  }

  static get NiagaraMonthlyV9() {
    return "niagara-monthly-v9"
  }

  static get NiagaraMonthlyV10() {
    return "niagara-monthly-v10"
  }
}

export class SubscriptionPlanPrices {
  static get NiagaraMonthlyV8() {
    return 9.99
  }

  static get NiagaraMonthlyV9() {
    return 19.99
  }

  static get NiagaraMonthlyV10() {
    return 34.99
  }
}

export const SubscriptionTiers = [
  {
    id: SubscriptionPlans.NiagaraMonthlyV8,
    price: SubscriptionPlanPrices.NiagaraMonthlyV8,
    studentPages: 5000,
    assignmentSlots: 45,
    gradesSynced: 100,
    label: "Starter",
  },
  {
    id: SubscriptionPlans.NiagaraMonthlyV9,
    price: SubscriptionPlanPrices.NiagaraMonthlyV9,
    studentPages: 10000,
    assignmentSlots: 100,
    gradesSynced: 250,
    label: "Expert",
  },
  {
    id: SubscriptionPlans.NiagaraMonthlyV10,
    price: SubscriptionPlanPrices.NiagaraMonthlyV10,
    studentPages: 20000,
    assignmentSlots: 200,
    gradesSynced: 500,
    label: "Champion",
  },
]

export class SubscriptionIntervals {
  static get Annual() {
    return "annual"
  }

  static get Monthly() {
    return "monthly"
  }

  static isMonthly(plan) {
    return SubscriptionIntervalsMap[plan] === SubscriptionIntervals.Monthly
  }
}

export const SubscriptionIntervalsMap = {
  [SubscriptionPlans.AntaresAnnualV1]: SubscriptionIntervals.Annual,
  [SubscriptionPlans.AntaresAnnualV2]: SubscriptionIntervals.Annual,
  [SubscriptionPlans.NiagaraAnnualV1]: SubscriptionIntervals.Annual,
  [SubscriptionPlans.NiagaraMonthlyV1]: SubscriptionIntervals.Monthly,
  [SubscriptionPlans.NiagaraAnnualV2]: SubscriptionIntervals.Annual,
  [SubscriptionPlans.NiagaraMonthlyV2]: SubscriptionIntervals.Monthly,
  [SubscriptionPlans.NiagaraAnnualV3]: SubscriptionIntervals.Annual,
  [SubscriptionPlans.NiagaraMonthlyV3]: SubscriptionIntervals.Monthly,
  [SubscriptionPlans.NiagaraAnnualV4]: SubscriptionIntervals.Annual,
  [SubscriptionPlans.NiagaraMonthlyV4]: SubscriptionIntervals.Monthly,
  [SubscriptionPlans.NiagaraAnnualV6]: SubscriptionIntervals.Annual,
  [SubscriptionPlans.NiagaraMonthlyV6]: SubscriptionIntervals.Monthly,
  [SubscriptionPlans.NiagaraAnnualV7]: SubscriptionIntervals.Annual,
  [SubscriptionPlans.NiagaraMonthlyV7]: SubscriptionIntervals.Monthly,
  [SubscriptionPlans.NiagaraMonthlyV8]: SubscriptionIntervals.Monthly,
  [SubscriptionPlans.NiagaraMonthlyV9]: SubscriptionIntervals.Monthly,
  [SubscriptionPlans.NiagaraMonthlyV10]: SubscriptionIntervals.Monthly,
}

export class SubscriptionCoupons {
  static init() {
    this.coupons = new Map([
      [
        SubscriptionCoupons.NiagaraMonthlyCouponV8.toLowerCase(),
        {
          code: SubscriptionCoupons.NiagaraMonthlyCouponV8,
          description: "50% off for the first 4 months",
          discountPercentage: "50%",
          expirationDate: undefined,
          plans: undefined, // Available for all plans
        },
      ],
      [
        SubscriptionCoupons.GET50OFF.toLowerCase(),
        {
          code: SubscriptionCoupons.GET50OFF.toLowerCase(),
          description: "🎉 50% off for the first month!",
          discountPercentage: "50%",
          expirationDate: undefined,
          plans: undefined, // Available for all plans
        },
      ],
      [
        SubscriptionCoupons.REFER25.toLowerCase(),
        {
          code: SubscriptionCoupons.REFER25.toLowerCase(),
          description: "🎉 25% Discount for the next 3 months!",
          discountPercentage: "25%",
          expirationDate: undefined,
          plans: [
            SubscriptionPlans.NiagaraMonthlyV8,
            SubscriptionPlans.NiagaraMonthlyV9,
            SubscriptionPlans.NiagaraMonthlyV10,
          ],
        },
      ],
      [
        SubscriptionCoupons.REFER50.toLowerCase(),
        {
          code: SubscriptionCoupons.REFER50.toLowerCase(),
          description: "🎉 50% Discount for the next 3 months!",
          discountPercentage: "50%",
          expirationDate: undefined,
          plans: [
            SubscriptionPlans.NiagaraMonthlyV8,
            SubscriptionPlans.NiagaraMonthlyV9,
            SubscriptionPlans.NiagaraMonthlyV10,
          ],
        },
      ],
      [
        SubscriptionCoupons.STARTER50.toLowerCase(),
        {
          code: SubscriptionCoupons.STARTER50.toLowerCase(),
          description: "🎉 $4/mo for the next 2 months!",
          discountPercentage: "60%",
          expirationDate: undefined,
          plans: [SubscriptionPlans.NiagaraMonthlyV8],
        },
      ],
      [
        SubscriptionCoupons.FINAID75.toLowerCase(),
        {
          code: SubscriptionCoupons.FINAID75.toLowerCase(),
          description: "🎉 75% off for the next 3 months!",
          discountPercentage: "75%",
          expirationDate: undefined,
          plans: [
            SubscriptionPlans.NiagaraMonthlyV8,
            SubscriptionPlans.NiagaraMonthlyV9,
            SubscriptionPlans.NiagaraMonthlyV10,
          ],
        },
      ],
      [
        SubscriptionCoupons.GOPRO20.toLowerCase(),
        {
          code: SubscriptionCoupons.GOPRO20.toLowerCase(),
          description: "🎉 20% off for the next 24 months!",
          discountPercentage: "20%",
          expirationDate: moment("2026-08-31"),
          plans: [
            SubscriptionPlans.NiagaraMonthlyV8,
            SubscriptionPlans.NiagaraMonthlyV9,
            SubscriptionPlans.NiagaraMonthlyV10,
          ],
        },
      ],
    ])
  }

  static get NiagaraAnnualLegacyV1() {
    return "niagara-annual-legacy-v1"
  }

  static get NiagaraMonthlyLegacyV1() {
    return "niagara-monthly-legacy-v1"
  }

  static get NiagaraMonthlyCouponV8() {
    return "niagara-monthly-coupon-v8"
  }

  static get FINAID75() {
    return "finaid75"
  }

  static get GET50OFF() {
    return "get50off"
  }

  static get REFER25() {
    return "refer25"
  }

  static get REFER50() {
    return "refer50"
  }

  static get STARTER50() {
    return "starter50"
  }

  static get GOPRO20() {
    return "gopro20"
  }

  /**
   * Get a coupon by code, checking if it's still valid (not expired) and applicable to the specified plan
   * @param {string} couponCode - The coupon code to look up
   * @param {moment|Date|string} [currentDate] - The current date to check against (defaults to now)
   * @param {string} [subscriptionPlan] - The subscription plan to validate against
   * @returns {object|undefined} - The coupon object if valid, not expired, and applicable to the plan; undefined otherwise
   */
  static getCoupon(
    couponCode,
    currentDate = moment(),
    subscriptionPlan = undefined,
  ) {
    if (!couponCode) return undefined

    const couponData = this.coupons.get(couponCode.toLowerCase())
    if (!couponData) return undefined

    // Check if coupon has expired
    if (
      couponData.expirationDate !== undefined &&
      couponData.expirationDate !== null
    ) {
      const checkDate = moment.isMoment(currentDate)
        ? currentDate
        : moment(currentDate)

      if (checkDate.isAfter(couponData.expirationDate)) {
        return undefined // Coupon has expired
      }
    }

    // Check if coupon is valid for the specified plan
    if (subscriptionPlan && couponData.plans !== undefined) {
      // If plans array is defined, check if the subscription plan is included
      if (!couponData.plans.includes(subscriptionPlan)) {
        return undefined // Coupon not valid for this plan
      }
    }

    return couponData
  }
}

SubscriptionCoupons.init()

export class SubscriptionStatus {
  static get Created() {
    return "created"
  }

  static get Trialing() {
    return "trialing"
  }

  static get Active() {
    return "active"
  }

  static get PastDue() {
    return "past_due"
  }

  static get Cancelled() {
    return "cancelled"
  }

  static get All() {
    return [
      SubscriptionStatus.Created,
      SubscriptionStatus.Trialing,
      SubscriptionStatus.Active,
      SubscriptionStatus.PastDue,
      SubscriptionStatus.Cancelled,
    ]
  }
}

export default class Subscription {
  constructor(
    id,
    ownerId,
    contractId,
    status,
    provider,
    active,
    created,
    updated,
    subscriptionPlan,
    coupon,
  ) {
    this._id = id
    this._ownerId = ownerId
    this._contractId = contractId
    this._status = status
    this._provider = provider
    this._active = active
    this._created = created ? moment(created) : undefined
    this._updated = updated ? moment(updated) : undefined
    this._subscriptionPlan = subscriptionPlan
    this._coupon = coupon
  }

  /**
   * The number of days we add to a contract after the renewal date to give the user time to update payment info
   * in the event their payment fails and they need to update card info or find another way to pay. This is set
   * in web services but we use here to show an accurate renewal date.
   *
   * @return {number}
   */
  static get GracePeriod() {
    return 7
  }

  /**
   * @return {string}
   */
  static get GracePeriodUnit() {
    return "days"
  }

  /**
   * @return {string}
   */
  get id() {
    return this._id
  }

  /**
   * @return {string}
   */
  get ownerId() {
    return this._ownerId
  }

  /**
   * @return {string}
   */
  get contractId() {
    return this._contractId
  }

  /**
   * @return {string}
   */
  get status() {
    return this._status
  }

  /**
   * @return {string}
   */
  get provider() {
    return this._provider
  }

  /**
   * @return {boolean}
   */
  get active() {
    return this._active
  }

  /**
   * @return {moment}
   */
  get created() {
    return this._created
  }

  /**
   * @return {moment}
   */
  get updated() {
    return this._updated
  }

  /**
   * @returns {string}
   */
  get subscriptionPlan() {
    return this._subscriptionPlan
  }

  /**
   * @param value {string}
   */
  set subscriptionPlan(value) {
    this._subscriptionPlan = value
  }

  /**
   * @return {string}
   */
  get coupon() {
    return this._coupon
  }

  get nextCharge() {
    let clone = this._created.clone()
    let unit = this.subscriptionPlan?.includes("monthly") ? "month" : "years"
    return clone.add(1, unit).format("MMMM Do YYYY")
  }
}
